export default __webpack_public_path__ + "static/media/profile_bg.4672fd15.png";